export const IN_ARTICLE = 'in_article';
export const IN_ARTICLE_REVEAL = 'reveal';
export const IN_ARTICLE_LANDSCAPE = 'landscape';
